import { useSelector } from "react-redux";
import {
  selectAuthUser,
  selectIsAuthenticated,
} from "store/reducer/authUser";

/** Read-only auth state from Redux. Use `LoginPage` + `SetAuthUserData` to sign in, `useLogout` to sign out. */
export default function useAuth() {
  const user = useSelector(selectAuthUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return { user, isAuthenticated };
}
